<template>
	<div>
		<div v-if="download.length == 0" class="container">
			<div class="iv2-download__items-null row clearfix">
				<div class="column full">
					<div style="padding: 2rem 0;">
						<h4 class="size-28 text-center" style="font-weight: bold;">{{ $t('download.null_title') }}</h4>
						<p class="text-center">{{ $t('download.null_summary') }}</p>
					</div>
				</div>
				<div class="column full text-center">
					<span>
						<router-link
							to="/"
							class="theme__main-btn is-btn is-btn-ghost2 is-upper size-18"
							style="border: 0; letter-spacing: 2px; max-width: 100%; width: 300px; padding-top: 15px; padding-bottom: 15px;"
						>{{ $t('download.top_button') }}</router-link>
					</span>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="container">
				<div class="spacer height-60"></div>
				<div class="row clearfix">
					<div class="column full">
						<p class="text-pre m-0">{{ $t('download.message') }}</p>
					</div>
				</div>
				<div class="spacer height-60"></div>
			</div>

			<div class="container">
				<div class="row">
					<div v-for="item in download" :key="item.id" class="iv2-download-item my-4 col-md-6 col-xl-4">
						<div class="iv2-download-item__img fit-img">
							<picture>
								<source type="image/webp" :srcset="item.image + $t('general.image_webp')">
								<img class="m-0" :src="item.image" :alt="'「' + item.title + '」' + $t('download.alt') ">
							</picture>
						</div>
						<h3 class="iv2-download-item__title">{{ item.title }}</h3>
						<p class="iv2-download-item__summary">{{ item.summary }}</p>
						<span>
							<a
								:href="item.href"
								@click="doAction(item.id)"
								target="_blank"
								class="theme__sub-btn is-btn is-btn-ghost2 size-18"
								style="letter-spacing: 2px; max-width: 100%;"
							>{{ $t('download.button') }}</a>
						</span>
					</div>
				</div>
				<div class="spacer height-60"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ["download"],

	data() {
		return {
		};
	},

	methods: {
		doAction(val) {
			const id = process.env.VUE_APP_SITE_ID;
			const key = 'download';
			window.ivSendActivities(id, {user_agent: navigator.userAgent.toLowerCase(),provide_name: key,provide_id: val}, 'production');
		},
	},
};
</script>

<style lang="scss">
.iv2-download__items-null {
	padding: 8rem 0;
}

.iv2-download-item__img {
	height: 200px;
	-webkit-transition: 0.3s;
	transition: 0.3s;
}

.iv2-download-item__title {
	font-size: 1.1rem;
	font-weight: bold;
}
</style>